"use client";

import { motion } from "framer-motion";
import { ScrollIcon } from "../_components/TopSection";
import { SectionHeader } from "../_components/SectionHeader";

const CircleAnimation = () => {
  return (
    <div className="relative w-64 h-64 md:w-80 md:h-80 mx-auto rounded-full">
      <motion.div
        className="absolute w-full h-full rounded-full bg-gray-200"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      />
      <motion.div
        className="absolute top-1/2 left-1/2 w-3 h-3 md:w-4 md:h-4 rounded-full bg-gray-600"
        initial={{ scale: 0 }}
        animate={{ scale: 1, x: "-50%", y: "-50%" }}
        transition={{ delay: 1, duration: 0.5 }}
      />
    </div>
  );
};

const AxisPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <section className="flex flex-col lg:flex-row items-center justify-center min-h-[calc(100vh-160px)] gap-8 md:gap-12">
        <motion.h1
          className="text-4xl md:text-5xl font-bold text-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          私たちの軸
        </motion.h1>
        <CircleAnimation />
        <div className="w-full flex flex-col items-center justify-center absolute bottom-20">
          <ScrollIcon />
        </div>
      </section>

      <div className="flex flex-col gap-40">
        <section>
          <SectionHeader color="red" text="Mission" />
          <div className="flex flex-col gap-10">
            <h3 className="text-2xl font-bold mb-4">
              世界中の意思決定を、イノベーションで更新し続ける
            </h3>
            <div>
              <p className="text-gray-700 mb-4">
                人類は常に、より良い意思決定のためにインフラを作ってきました。
                地図、統計、コンピュータ——あらゆる発明の根底には、「もっと正しく判断したい」という意志がある。
              </p>
              <p className="text-gray-700 mb-4">
                しかし今なお、多くの意思決定は勘と前例に頼っています。
                イノベーションは一部の天才やトップ企業の特権にとどまり、本来それを最も必要とする現場には届いていない。
              </p>
              <p className="text-gray-700">
                CoPaletteは、イノベーションをあらゆる組織の日常にする。
                アイデアが生まれる場所から、都市や社会に実装されるまで——
                意思決定の質を変えるインフラを、私たちはつくり続けます。
              </p>
            </div>
          </div>
        </section>

        <section>
          <SectionHeader color="yellow" text="Purpose" />
          <div className="flex flex-col gap-10">
            <h3 className="text-2xl font-bold mb-4">
              イノベーションを、アイデアで終わらせない
            </h3>
            <div>
              <p className="text-gray-700 mb-4">
                「Community & Color
                Palette」——人との繋がりと、その多様な個性を意味してCoPaletteという社名は生まれました。
              </p>
              <p className="text-gray-700 mb-4">
                良いアイデアは、世界中の至る所で毎日生まれている。
                しかしその大半は、実行の手段がないまま消えていく。
              </p>
              <p className="text-gray-700">
                私たちは、アイデアを持つ人と、それを形にする技術・データ・機会をつなぐ存在です。
                構想を構想のまま終わらせず、社会を動かす力に変える。それがCoPaletteの役割です。
              </p>
            </div>
          </div>
        </section>

        <section>
          <SectionHeader color="green" text="4Values" />
          <div className="flex flex-col gap-10">
            <h3 className="text-2xl font-bold mb-4">行動指針</h3>
            <p className="text-gray-700 mb-8">
              壮大なミッションも、日々の行動の積み重ねでしか実現できない。
            </p>
            <ol className="list-decimal list-inside space-y-5 text-gray-700 font-bold text-base">
              <li>新しいことにチャレンジする</li>
              <li>違和感を素直に言葉にし、次の提案と行動を</li>
              <li>実直にやり切る</li>
              <li>お客様に丁寧さと期待感を</li>
            </ol>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AxisPage;
